import { Button, makeStyles, Typography, Chip } from "@material-ui/core";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "components/ErrorMessage";
import useErrorCatcher from "utils/useErrorCatcher";
import { Lesson } from "services";
import LoadingIndicator from "components/LoadingIndicator";
import { Link as RouterLink } from "react-router-dom";
import SchoolIcon from '@material-ui/icons/School';

const useStyles = makeStyles(theme => ({
  buttons: {
    padding: theme.spacing(2),
  },
  chip: {
    margin: theme.spacing(0.5)
  },
}));

const SlotTooltip = props => {
  const { slot, handleActivityOpen } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const [lesson, setLesson] = useState(null);

  const reload = () => {
    setLoading(true);
    runAsyncBlock(async () => {
      const { model } = await Lesson.detail(slot.lesson_id);
      setLesson(model);
    }).finally(() => setLoading(false));
  }

  useEffect(() => {
    reload();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <ErrorMessage message={errorMessage} />
      <LoadingIndicator active={loading} />
      <Typography variant="h5">{slot.name_en}</Typography>
      <Typography variant="caption">{moment(slot.start_at).format("HH:mm")} - {moment(slot.start_at).add(slot.duration, "s").format("HH:mm")} ({slot.duration / 60} min)</Typography>
      <div>
        {lesson && lesson.teachers.map((teacher, index) => (
          <Chip avatar={<SchoolIcon />} variant="outlined" clickable to={`/teachers/${teacher.id}/summary`} component={RouterLink} size="small" label={teacher.name_en} className={classes.chip} />
        ))}
      </div>
      <div className={classes.buttons}>
        <Button size="small" to={`/lesson_slots/${slot.id}/summary`} component={RouterLink} color="primary">View</Button>
        <Button size="small" color="primary" onClick={() => handleActivityOpen(slot.id)}>Create Activity</Button>
      </div>
    </Fragment>
  );
}

export default SlotTooltip;